import { UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { checkUserPermissionFunc } from "./CommonFunctions";

const QuickRegisterCandidateButton = ({ className = "" }) => {
    const navigate = useNavigate();
    const { add: canAdd } = checkUserPermissionFunc("employee", "employees", "SubMenu");

    if (!canAdd) {
        return null;
    }

    return (
        <Button
            variant="brand"
            onClick={() => navigate("/employee/quick-register")}
            className={`flex items-center gap-2 px-4 py-2 rounded-md transition-colors ${className}`}
        >
            <UserPlus className="w-4 h-4" />
            Quick Register
        </Button>
    );
};

export default QuickRegisterCandidateButton;
